import { render, staticRenderFns } from "./ProgressTabAdministratorTasks.vue?vue&type=template&id=255484b6&"
import script from "./ProgressTabAdministratorTasks.vue?vue&type=script&lang=ts&"
export * from "./ProgressTabAdministratorTasks.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressTabAdministratorTasks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports